export enum AuthRouterNames {
    LOGIN = 'login',
    FORGOT_PASSWORD = 'forgot-password',
    RESET_PASSWORD = 'reset-password',
}
